module.exports = __webpack_public_path__ + "img/wallet_01_lake.525e2cbe.avif";